<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
		<b-card>
			<b-row>
				<b-col cols="12">
					<app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
				</b-col>
			</b-row>
			<b-row v-if="isUploadSuccess">
				<b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Delegation Setting" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="delegationSettingPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="delegationSettings" :fields="fieldsDelegationSetting" :busy="isDataLoading" :sort-by.sync="sortByDelegationSetting" :sort-desc.sync="sortDescDelegationSetting" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowDelegationSettingFilter = !isShowDelegationSettingFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowDelegationSettingFilter">
										<b-th></b-th>
										<b-th stacked-heading="Delegate From">
											<b-form-input id="input-delegate-from-table" v-model="filterDelegationSetting.delegateFrom" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Delegate To">
											<b-form-input id="input-delegate-to-table" v-model="filterDelegationSetting.delegateTo" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Period From">
											<app-input-datetimepicker-range id="fieldset-period-from" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Period From" size="sm" :modelFrom.sync="filter.periodFromFrom" :modelTo.sync="filter.periodFromTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button/>
										</b-th>
										<b-th stacked-heading="Period To">
											<app-input-datetimepicker-range id="fieldset-period-to" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Period To" size="sm" :modelFrom.sync="filter.periodToFrom" :modelTo.sync="filter.periodToTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button/>
										</b-th>
										<b-th stacked-heading="Is All Time">
											<b-form-checkbox id="input-is-all-time-table" @change="getDelegationSettings" class="float-right" v-model="filterDelegationSetting.isAllTime"></b-form-checkbox>
										</b-th>
										<b-th stacked-heading="Remarks">
											<b-form-input id="input-remarks-table" v-model="filterDelegationSetting.remarks" size="sm"></b-form-input>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( delegationSettingPageSize * (currentDelegationSettingPage - 1))) }}
									</template>
									<template v-slot:cell(periodFrom)="row">
										{{ row.item.periodFrom | moment("DD-MMM-YYYY HH:mm")  }}
									</template>
									<template v-slot:cell(periodTo)="row">
										{{ row.item.periodTo | moment("DD-MMM-YYYY HH:mm")  }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentDelegationSettingPage"
									:total-rows="totalDelegationSettingRow"
									:per-page="delegationSettingPageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
			</b-row>
		</b-card>
		<template #modal-footer="{ ok, cancel }">
			<b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
				Download Log
			</b-button>
			<b-button size="sm" variant="success" class="float-right" @click="ok()">
				{{ okTitle }}
			</b-button>
			<b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
				Cancel
			</b-button>
		</template>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<style lang="scss" scoped>
.card {
	border: 1px solid rgba(0, 0, 0, 0.125) !important;
}
::v-deep.th-message {
	color: red;
}
::v-deep.modal-footer {
	display: block;
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate"; 
import { required, minLength } from "vuelidate/lib/validators"; 
import { saveAs } from 'file-saver';

import DelegationSetting from '@/models/DelegationSetting/DelegationSetting';
import DelegationSettingList from '@/models/DelegationSetting/DelegationSettingList';
import DelegationSettingFilter from '@/filters/DelegationSetting/DelegationSettingFilter';

import AppInputFileupload from '@/components/AppInputFileupload';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,AppInputDatetimepicker,AppInputDatetimepickerRange,},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fieldsDelegationSetting: [
				{"no" : { "class" : "th-number"}}, 
				{"delegateFrom": { "class" : "th-delegate-from", "label" : "Delegate From"}, key: 'delegateFrom', sortable: true}, 
				{"delegateTo": { "class" : "th-delegate-to", "label" : "Delegate To"}, key: 'delegateTo', sortable: true}, 
				{"periodFrom": { "class" : "th-period-from", "label" : "Period From"}, key: 'periodFrom', sortable: true}, 
				{"periodTo": { "class" : "th-period-to", "label" : "Period To"}, key: 'periodTo', sortable: true}, 
				{"isAllTime": { "class" : "th-is-all-time", "label" : "Is All Time"}, key: 'isAllTime', sortable: true}, 
				{"remarks": { "class" : "th-remarks", "label" : "Remarks"}, key: 'remarks', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isDataLoading: false,
			isBusy : false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			delegationSettings : [],
			delegationSettingId : '',
			totalDelegationSettingRow : 0,
			isShowDelegationSettingFilter: false,
			filterDelegationSetting : null,
			currentDelegationSettingPage : 1,
			delegationSettingPageSize: 10,
			sortByDelegationSetting: '',
			sortDescDelegationSetting: '',
			processId: "",
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'delegationsetting/confirmUpload',
					[],
					).then(async function(response){
						if (response != null) {
						if (response.data != null) {
							_this.resetModal();
							_this.datas = Array();
							_this.fileupload = null;
							_this.isUploadSuccess = false;
						}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
				let data = new FormData();
				data.append('file', this.fileupload);
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'delegationsetting/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.isBusy = false;
						_this.isUploadSuccess = true;
						_this.getDelegationSettings();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getDelegationSettings : async function() {
			let filter = {};
			Object.assign(filter, this.filterDelegationSetting);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingByDelegationSetting = Array();
			if (this.sortByDelegationSetting != null) {
				this.sortingByDelegationSetting[this.sortByDelegationSetting] = this.sortDescDelegationSetting;
			}
			let currentPage = (this.currentDelegationSettingPage - 1);
			DelegationSetting.getList(this, filter, this.sortingByDelegationSetting, currentPage , this.delegationSettingPageSize).then(result => {
				this.delegationSettings = result.data;
				this.totalDelegationSettingRow = result.dataCount;
			}).catch(error => {});
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		downloadLog() {
			let _this = this;
			this.$http.post(process.env.VUE_APP_API_URL + 'delegationsetting/downloadlog', [],
			{ headers: { 'Content-Type': 'application/json' }}
			).then(async function(response){
				await saveAs(process.env.VUE_APP_API_URL + 'delegationsetting/downloadlog', "DelegationSetting.xslx");
				_this.isBusy = false;
			})
			.catch(error => {
				_this.$store.dispatch('addErrorMessageGlobal', error);
				_this.isBusy = false;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		sortByDelegationSetting : {
			handler: function() {
				this.getDelegationSettings();
			}
		},
		sortDescDelegationSetting: {
			handler: function() {
				this.getDelegationSettings();
			}
		},
		currentDelegationSettingPage: {
			handler: function() {
				this.getDelegationSettings();
			}
		},
		delegationSettingPageSize : {
			handler: function() {
				this.getDelegationSettings();
			}
		},
		filterDelegationSetting: {
			handler: function() {
				this.getDelegationSettings();
			},
			deep: true,
		},
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Proses";
				}
				return "Simpan";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterDelegationSetting = new DelegationSettingFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
